<template>
  <div class="text-center">
    <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" max-width="1000" v-model="dialog" scrollable>
      <v-card>
        <v-card-title class="primary white--text text-uppercase" v-if="dialog === true">
          KHOẢN {{ titleType }} CỤ THỂ {{ rootPrice.period.title | convertFullDate }}<v-spacer></v-spacer>
          <v-btn dark icon>
            <v-icon @click="cancel">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text v-if="existData === false">
          <div
            class="d-flex flex-column justify-center align-center mx-auto"
            style="width: 330px; min-height: 320px"
            v-if="step === 'import'"
          >
            <v-img max-width="100px" max-height="100px" contain src="@/assets/upload-file.svg"></v-img>
            <div class="text-center content-text mt-5" @click="exportExcelTemplate">
              Chưa có thông tin. Tải tệp Excel (.xlsx) chứa danh sách học sinh và mức phí áp dụng
            </div>
            <div class="mt-5">
              <v-btn color="primary" class="mr-5" @click="exportExcelTemplate" outlined>Tải mẫu nhập</v-btn>
              <v-btn color="primary" class="elevation-0" :loading="isSelecting" @click="onExcelUpload">
                <div class="primary white--text">Chọn tệp</div>
                <input
                  ref="uploader"
                  type="file"
                  class="d-none"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xlsx"
                  @change="onFileChanged"
                />
              </v-btn>
            </div>
          </div>
          <div class="pt-4" style="height: 100%" v-else-if="step === 'upload'">
            <div class="d-flex align-center">
              <v-col md="4">
                <v-text-field
                  dense
                  class="width-286px"
                  v-model="selectedFile.name"
                  outlined
                  prepend-inner-icon="mdi-file"
                  disabled
                  hide-details
                >
                </v-text-field>
              </v-col>
              <v-btn color="primary" @click="reset" outlined class="search-button">Chọn tệp khác</v-btn>
            </div>
            <v-col v-if="isError === true">
              <h1 class="my-2 text-error">Lỗi dữ liệu</h1>
              <p>
                Vui lòng kiểm tra lại dữ liệu của dòng <span class="text-error">{{ getIndexError(indexError) }}</span
                ><span v-if="indexError.length > 3"> và <span class="text-error">các dòng khác</span></span
                >.
              </p>
            </v-col>
            <v-card outlined>
              <v-card outlined class="ma-3">
                <ListStudentPreview :priceStudent="priceStudents" />
              </v-card>
            </v-card>
          </div>
        </v-card-text>
        <v-card-text v-else-if="existData === true">
          <div class="pa-5" style="height: 100%">
            <v-card>
              <ListStudent :priceStudent="priceStudents" />
            </v-card>
            <div class="mt-3">
              <div class="text-body-2 font-weight-medium">Ghi chú chung</div>
              <div class="text-caption">Ghi chú này sẽ hiển thị trong trường hợp ghi chú riêng không tồn tại</div>
              <div class="mt-2" v-if="rootPrice.notes">{{ rootPrice.notes }}</div>
              <div class="mt-2 text-caption font-weight-medium red--text" v-else>Chưa có ghi chú chung</div>
            </div>
          </div>
        </v-card-text>
        <hr color="#E0E0E0" />
        <v-card-actions v-if="priceStudents.length > 0">
          <div class="d-flex justify-space-between align-center" style="width: 100%">
            <v-btn color="gray" class="ma-2 px-8" @click="cancel" outlined>Hủy</v-btn>
            <div v-if="step === 'upload'">
              <v-btn color="primary" class="elevation-0 px-8" @click="addPaymentPeriod" v-if="isError === false"
                >Lưu</v-btn
              >
              <v-btn
                color="primary"
                class="elevation-0 px-8"
                @click="addPaymentPeriod"
                disabled
                outlined
                v-if="isError === true"
                >Lưu</v-btn
              >
            </div>
            <v-btn
              color=""
              class="elevation-0 px-8 search-button"
              outlined
              @click="existData = false"
              v-if="existData === true"
              >Tải lên danh sách thay thế</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import readXlsxFile from 'read-excel-file'
import ListStudent from '@/modules/tuitionFee/head-fee/ImportExcelPaymentPeriodDialog/ListStudent'
import ListStudentPreview from '@/modules/tuitionFee/head-fee/ImportExcelPaymentPeriodDialog/ListStudentPreview'
import checkData from '@/modules/tuitionFee/head-fee/helper/checkData.js'
import utils from '@/plugins/utils'
import { dataExampleFile, headerSampleFile, schema } from '@/modules/tuitionFee/head-fee/helper/headerHelper'

export default {
  components: {
    ListStudent,
    ListStudentPreview
  },
  data() {
    return {
      rootPrice: '',
      dialog: false,
      progress: 1,
      isSelecting: false,
      selectedFile: null,
      step: 'import',
      indexError: [],
      isError: false,
      priceStudents: [],
      existData: false
    }
  },
  computed: {
    ...mapGetters({
      selectedStudent: 'tuitionFeeGroupStudent/selectedStudent'
    }),
    ...mapState('tuitonFeeHeadFee', ['headFee', 'router', 'isSubFee']),
    titleType() {
      return this.$route.meta.title.replace('Chi tiết khoản ', '')
    }
  },
  methods: {
    ...mapActions('tuitionFeePriceStudent', [
      'createTuitionFeePriceStudent',
      'fetchPriceStudents',
      'removePriceStudents'
    ]),
    cancel() {
      this.dialog = false
      setTimeout(() => {
        this.reset()
      }, 200)
    },
    reset() {
      this.paymentPeriod = []
      this.isError = false
      this.existData = false
      this.selectedFile = null
      this.step = 'import'
    },
    onExcelUpload() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )

      this.$refs.uploader.click()
    },
    async addPaymentPeriod() {
      this.$loadingCount.start({ count: 0, total: this.priceStudents.length, msg: 'Đang tải lên ', postfix: 'học sinh' })
      let params = {
        rootPrice: this.rootPrice,
        students: this.priceStudents,
        headFee: this.headFee
      }
      await this.removePriceStudents(this.rootPrice)
      await this.createTuitionFeePriceStudent(params)
      this.$loadingCount.end()
      this.cancel()
    },
    async onFileChanged(e) {
      this.$loading.active = true
      this.selectedFile = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(this.selectedFile, {
          schema
        })
      } catch (error) {
        this.$alert.error('File không có định dạng .xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)')
        this.$loading.active = false
        return
      }
      if (readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(`Lỗi Dòng ${error.row} - Cột ${error.column} - ${error.value}: ${error.error}`)
        this.$loading.active = false
        return
      } else {
        const results = readFileResult.rows
        this.step = 'upload'
        let data = checkData.checkDataFileExcel(results, this.$route.name)
        this.isError = data.isError
        this.priceStudents = data.students
        this.indexError = data.indexError
      }
      this.$loading.active = false
    },
    async exportExcelTemplate() {
      this.$loading.active = true
      utils.exportExcel(
        dataExampleFile(this.router, this.isSubFee),
        headerSampleFile,
        `Danh sách mức ${this.titleType} cụ thể ${this.$options.filters.convertFullDate(this.rootPrice.period.title)}`
      )
      this.$loading.active = false
    },
    async openDialog(rootPrice) {
      this.rootPrice = rootPrice
      await this.checkData(rootPrice)
      this.dialog = true
    },
    async checkData() {
      this.$loading.active = true
      let priceStudents = await this.fetchPriceStudents(this.rootPrice)
      if (priceStudents.length === 0) {
        this.existData = false
      } else {
        this.priceStudents = priceStudents
        this.existData = true
      }
      this.$loading.active = false
    },
    getIndexError(indexError) {
      if (indexError.length >= 3) {
        return `${indexError[0]}, ${indexError[1]}, ${indexError[2]}`
      } else if (indexError.length >= 2) {
        return `${indexError[0]}, ${indexError[1]}`
      } else {
        return `${indexError[0]}`
      }
    }
  }
}
</script>
<style scoped>
.text-error {
  color: #fd6b6b;
}
</style>
